/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:51:06
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-19 18:14:43
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/index.tsx
 */
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

// import GeneralCollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseWrapper';
// import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
// import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
// import { Collapse } from '@/src/components/Antd';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { currentSelectedSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
import CollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelCollapseWrapper';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { useError } from './hooks';

// const headerPropsProcessor = (headerProps, isPrimary) => {
//   const _headerProps = { ...(headerProps || {}) };
//   if (_headerProps.hideDotsWhenNotPrimary && !isPrimary) {
//     _headerProps.hasDots = false;
//   }
//   return _headerProps;
// };

const ErrorProcessingHOC = (Component: any, obj?: any) => {
  const {
    getCollapseOpenStatus,
    onCollapseOpen,
    headerProps = {},
    id,
    getContent,
    title,
    getErrorDisplay,
    onErrorChange,
    validation,
    expandOffset,
    getSubmitStamp,
    isNotRedux,
    bordered,
    collapseProps: _collapseProps,
  } = obj;
  //console.log('obj', obj);

  const WrappedComponent = (props) => {
    const { disabled, withoutCollapse, collapseOpenDefault } = props;
    const _d = useDispatch();
    const isPrimary = useSelector(isPrimaryLanguage());
    const currentStyle = useSelector(currentSelectedStyle());
    const currentSize = useSelector(currentSelectedSize());
    const currentLanguage = useQueryLanguageListContentEditor();

    const _e: any = getErrorDisplay
      ? isNotRedux
        ? getErrorDisplay(id)
        : useSelector(getErrorDisplay(id))
      : { display: false, hasError: false };
    // console.log('id', id);
    // console.log('e', _e);

    const { display: _display, hasError: _hasError } = _e || {};

    const _open =
      collapseOpenDefault ||
      withoutCollapse ||
      (isNotRedux
        ? getCollapseOpenStatus(id)
        : useSelector(getCollapseOpenStatus(id)));

    const _data: any = getContent
      ? isNotRedux
        ? getContent()
        : useSelector(getContent())
      : {}; //最好别在这里更新数据
    // console.log('_data', _data);
    const stamp = getSubmitStamp
      ? isNotRedux
        ? getSubmitStamp()
        : useSelector(getSubmitStamp())
      : null;
    // console.log('id', id);
    // console.log('stamp', stamp);

    const {
      specificError, //->对应现在应该显示error,对应pDataError里面的数据
      generalError, //->对应现在应该显示error,对应pDataError里面的数据
      currentHasPreviousError, //->对应现在应该显示HasError,对应pDataError里面的数据
      currentHasError,
    } = useError({
      data: _data,
      open: _open,
      display: _display,
      validation: validation
        ? (x) => {
            return validation(x, {
              isPrimary,
              style: currentStyle,
              breakpoint: currentSize,
            });
          }
        : null,
      isPrimary,
      stamp,
      errorDisplayHasError: _hasError,
      onErrorChange,
      id,
      isRedux: true,
    });

    const handleOnCollapseOpen = (status) => {
      const _g = status ? [id] : [];
      if (isNotRedux) {
        onCollapseOpen({ idArr: _g });
      } else {
        _d(onCollapseOpen({ idArr: _g }));
      }
    };

    // const renderTitle = () => {
    //   return (
    //     <GeneralCollapseHeader
    //       content={title}
    //       err={_display && currentHasPreviousError}
    //       {...(headerPropsProcessor(headerProps, isPrimary) || {})}
    //     />
    //   );
    // };

    const returnProps = {
      specificError: specificError || {},
      data: _data,
      display: _display,
      currentHasError,
      isPrimary,
      ...props,
    };

    const collapseProps = {
      id,
      open: _open,
      title,
      displayError: _display && currentHasPreviousError,
      headerProps: !disabled && headerProps,
      isPrimary,
      generalError,
      expandOffset: collapseOpenDefault ? 0 : expandOffset,
      bordered,
      onCollapseOpen: handleOnCollapseOpen,
      collapseProps: _collapseProps,
      currentLanguage,
      withoutCollapse,
    };

    return (
      <CollapseWrapper {...collapseProps}>
        <Component {...returnProps} />
      </CollapseWrapper>
      // <GeneralCollapseWrapper>
      //   <Collapse
      //     id={id}
      //     err={null}
      //     open={_open}
      //     title={renderTitle()}
      //     content={
      //       <GeneralCollapseContent err={generalError}>
      //         <Component {...returnProps} />
      //       </GeneralCollapseContent>
      //     }
      //     clickToExpand
      //     expandOffset={12}
      //     onClickTrigger={handleOnCollapseOpen}
      //   />
      // </GeneralCollapseWrapper>
    );
  };
  return WrappedComponent;
};
export default ErrorProcessingHOC;
